import * as z from "zod/v4";
import { object, string } from "zod/v4";
export const polishMessage = {
  name: "polishMessage" as const,
  input: object({ draftId: string(), conversationId: string() }),
  output: object({ polishedResponse: string() }),
};

export type PolishMessageInput = z.infer<typeof polishMessage.input>;
export type PolishMessageOutput = z.infer<typeof polishMessage.output>;
